<p>confirmation-edit-position works!</p>
